module.exports = __webpack_public_path__ + "static/p04_burro-7e81eeb34f3de7872bc8450defe49107.png";